import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import App from "./App.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);
